import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import '../styles/About.css';

const About = () => {
  return (
    <div className="about-page">
      <h2>About the Game of Go</h2>
      
      <section className="game-intro">
        <Row>
          <Col md={6}>
            <p className="lead">
              Go is an ancient board game that originated in China more than 2,500 years ago. 
              It's the oldest board game still played in its original form today.
            </p>
            
            {/* Mobile image placement - shows after first paragraph */}
            <div className="about-image-mobile d-md-none mb-4">
              <img 
                src="/resources/images/club/Unfinished-game.png" 
                alt="Complex Go position showing the depth and beauty of ancient strategy" 
                className="img-fluid rounded"
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/500x400/2c5f41/ffffff?text=Go+Strategy";
                }}
              />
              <small className="text-muted">
              </small>
            </div>
            
            <p>
              The rules of Go are simple to learn, but the game offers endless strategic possibilities. 
              Players take turns placing black and white stones on a 19×19 grid, aiming to surround territory 
              while balancing offense and defense across the board.
            </p>
            <p>
              Go has been highly regarded throughout history. In ancient China, it was considered one of the four essential arts of 
              the cultured scholar. Today, Go continues to fascinate players worldwide and has even served as an important 
              benchmark for advances in artificial intelligence.
            </p>
            <p>
              In our fast-paced culture, Go offers something profound and enduring. This ancient game teaches 
              patience, deep thinking, and long-term strategy—wisdom that remains as relevant today as it was millennia ago.
            </p>
            <p>
              Our community keeps this tradition alive, connecting players from many backgrounds to these timeless lessons. 
              In a world of instant gratification, Go reminds us that the most valuable insights come through planning and patience.
            </p>
            <Button 
              variant="primary" 
              href="/howtoplay" 
              className="mt-3"
            >
              Learn How to Play
            </Button>
          </Col>
          
          {/* Desktop image placement - shows on the right */}
          <Col md={6} className="d-none d-md-block">
            <div className="about-image">
              <img 
                src="/resources/images/club/Unfinished-game.png" 
                alt="Complex Go position showing the depth and beauty of ancient strategy" 
                className="img-fluid rounded"
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/500x400/2c5f41/ffffff?text=Go+Strategy";
                }}
              />
              <small className="text-muted">
              </small>
            </div>
          </Col>
        </Row>
      </section>

      <section className="club-gallery mt-5">
        <h3>Community Events</h3>
        <p className="mb-4">
          The Birmingham Go Club brings together players of all skill levels in Birmingham. 
          Join us every Sunday for games, learning, and community!
        </p>
        
        <Row className="g-4">
          <Col md={4}>
            <div className="club-image">
              <img 
                src="/resources/images/club/Atlanta-tournament-afterparty-teaching.jpeg" 
                alt="Teaching and learning at tournament afterparty" 
                className="img-fluid rounded"
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/400x300/3a7ca5/ffffff?text=Teaching+Games";
                }}
              />
              <small className="text-muted">
                Learning continues even after tournaments - teaching games and analysis
              </small>
            </div>
          </Col>
          <Col md={4}>
            <div className="club-image">
              <img 
                src="/resources/images/club/Cherry-blossom-festival.jpeg" 
                alt="Birmingham Go Club sharing Go at Cherry Blossom Festival" 
                className="img-fluid rounded"
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/400x300/5a8c7a/ffffff?text=Community+Outreach";
                }}
              />
              <small className="text-muted">
                We share the joy of Go at community events like the Cherry Blossom Festival
              </small>
            </div>
          </Col>
          <Col md={4}>
            <div className="club-image">
              <img 
                src="/resources/images/club/Tournament-game.jpeg" 
                alt="Intense tournament game showing Go strategy and concentration" 
                className="img-fluid rounded"
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/400x300/7ba05b/ffffff?text=Tournament+Game";
                }}
              />
              <small className="text-muted">
                Tournament play showcases the deep strategic complexity of Go
              </small>
            </div>
          </Col>
        </Row>
        
        <Row className="mt-4">
          <Col className="text-center">
            <p>
              Follow us on <a href="https://www.instagram.com/steelcitygoclub" target="_blank" rel="noopener noreferrer" className="social-link">
                Instagram @steelcitygoclub
              </a> for updates and photos from our weekly meetings!
            </p>
            <Button 
              variant="outline-primary" 
              href="/contact" 
              className="mt-2"
            >
              Join Our Club
            </Button>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default About; 